<template>
  <div class="game-card">
    <a :class="{'disabled': !hasPage}" class="game-card__body" :href="pageUrl">
      <div class="game-card__image _ibg" ref="image-container">
        <img :src="imageUrl" alt="kendoo">
      </div>
      <div class="game-card__release-date"><DateWidget :iso-date-string="releaseDate"/></div>
      <div class="game-card__description" :class="{'_icon-arrow-3': hasPage}">
        <p>{{ text }}</p>
      </div>
    </a>
  </div>
</template>


<script>
import {loadAndAppendImageAnimated} from "@/lib/common_utils";

import DateWidget from "@/components/date_widget";

export default {
    name: "GamesGridCard",
    components: {
        DateWidget,
    },
    props: {
        imageUrl: String,
        releaseDate: String,
        text: String,
        hasPage: Boolean,
        pageUrl: String,
        preload: false,
    },

    data() {
        return {
            preloadedImg: new Image(),
        }
    },

    watch: {
        imageUrl(oldV, newV) {
            this.updateImg();
        }
    },

    mounted() {
        this.updateImg();
    },

    methods: {
        updateImg() {
            let imgContainerEl = this.$refs["image-container"];
            imgContainerEl.innerHTML = '';
            if (this.preload) {
                loadAndAppendImageAnimated(imgContainerEl, this.preloadedImg, this.imageUrl);
            } else {
                this.preloadedImg.src = this.imageUrl;
                imgContainerEl.appendChild(this.preloadedImg);
            }
        }
    }
}
</script>
